import React from "react";
import "./TermsAndConditions.css";

export default function TermsAndConditions() {
  const sections = [
    {
      title: "1. Services Overview",
      content: [
        "Custom Website Design & Development",
        "Web Application Development",
        "Frontend & Backend Development",
        "Database Design, Migration, Optimization & Maintenance",
        "Data Backup & Recovery Solutions",
        "API Integration & Support",
      ],
    },
    {
      title: "2. Client Responsibilities",
      content:
        "You agree to provide accurate requirements, data, and access. Backups are your responsibility unless otherwise agreed. Services must not be misused.",
    },
    {
      title: "3. Project Scope & Revisions",
      content:
        "Project scope is finalized before start. Extra work may cost more. Revisions are limited as per agreement.",
    },
    {
      title: "4. Database Services Terms",
      content:
        "We ensure secure and optimized databases, but aren't liable for external hosting issues. Share credentials securely.",
    },
    {
      title: "5. Payment Terms",
      content:
        "Milestone-based payments apply. Late payments can pause work. Monthly billing for ongoing work.",
    },
    {
      title: "6. Confidentiality",
      content:
        "All shared data stays private. We may list projects in our portfolio unless asked not to.",
    },
    {
      title: "7. Intellectual Property",
      content:
        "Once paid fully, the client owns all code/design. Generic code remains reusable by us.",
    },
    {
      title: "8. Warranty & Support",
      content:
        "Bug fixes are supported for 15–30 days. Ongoing maintenance is available separately.",
    },
    {
      title: "9. Limitation of Liability",
      content:
        "We are not liable for third-party failures. Our liability is limited to the project fee.",
    },
    {
      title: "10. Termination",
      content:
        "Either party can terminate with notice. All completed work until then must be paid.",
    },
    {
      title: "11. Modifications",
      content:
        "We may update terms. Continued usage means acceptance of updated terms.",
    },
    {
      title: "12. Governing Law",
      content:
        "Terms are governed by Indian law. Disputes fall under courts of your city.",
    },
  ];

  return (
    <div className="terms-wrapper">
      <div className="terms-section header">
        <h2>Terms & Conditions</h2>
        <p>
          Welcome to <strong>Clota Technology</strong>. By accessing or using
          our website or services, you agree to comply with and be bound by the
          following terms. Please read them carefully.
        </p>
      </div>

      {sections.map((section, index) => (
        <div key={index} className="terms-section">
          <h4>{section.title}</h4>
          {Array.isArray(section.content) ? (
            <ul>
              {section.content.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          ) : (
            <p>{section.content}</p>
          )}
        </div>
      ))}

      <div className="terms-section contact">
        <h4>📬 Contact Us</h4>
        <p>
          <strong>Clota Technology</strong>
        </p>
        <p>Email: support@clotatechnology.com</p>
        <p>Phone: +91 9490384177</p>
        <p>Website: www.clotatech.com</p>
      </div>
    </div>
  );
}
